import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Box from 'reusecore/src/elements/Box';
import Text from 'reusecore/src/elements/Text';
import Heading from 'reusecore/src/elements/Heading';
import Button from 'reusecore/src/elements/Button';
import FeatureBlock from 'common/src/components/FeatureBlock';
import Container from 'common/src/components/UI/Container';
import Particles from '../../Agency/Particle';
import BannerWrapper, { DiscountLabel } from './bannerSection.style';
import { textAlign } from 'styled-system';

const BannerSection = ({
  row,
  col,
  title,
  btnStyle,
  description,
  discountText,
  discountAmount,
  outlineBtnStyle,
  govIcon,
}) => {
  const ButtonGroup = () => (
    <Fragment>
      <Button title="I’m looking for skill development" {...btnStyle} />
      {/* <Button
        title="WATCH WORKS"
        variant="textButton"
        icon={<i className="flaticon-next" />}
        {...outlineBtnStyle}
      /> */}
    </Fragment>
  );
  return (  
    <BannerWrapper>
      {/* <Particles /> */}
      <Container>
        <Box className="row" {...row}>
          <Box className="col" {...col}>
            {/* <DiscountLabel>
              <Text content="25% Discount" {...discountAmount} />
              <Text content="on every first project budget" {...discountText} />
            </DiscountLabel> */}
            <FeatureBlock
              title={
                <Heading
                  content="Youth education, welfare & employability"
                  {...title}
                />
              }
              govIcon={govIcon}
              button={<ButtonGroup />}
              description={
                <Text
                  content="YUVA is an initiative to empower youth with access to information, opportunity & tools for holistic personal development."
                  {...description}
                />
              }
              
            />
          </Box>
        </Box>
      </Container>
    </BannerWrapper>
  );
};

BannerSection.propTypes = {
  title: PropTypes.object,
  btnStyle: PropTypes.object,
  description: PropTypes.object,
  contentStyle: PropTypes.object,
  discountText: PropTypes.object,
  discountAmount: PropTypes.object,
  outlineBtnStyle: PropTypes.object,
  govIcon: PropTypes.any,
  
};

BannerSection.defaultProps = {
  row: {
    flexBox: true,
    flexWrap: 'wrap',
    ml: '-15px',
    mr: '-15px',
    alignItems: 'center',
  },
  col: {
    pr: '15px',
    pl: '15px',
    width: ['100%', '70%', '60%', '50%'],
  },
  title: {
    fontSize: ['26px', '34px', '42px', '55px'],
    fontWeight: '400',
    color: '#333333',
    letterSpacing: '-0.025em',
    mb: ['30px', '60px'],
    lineHeight: '1.31',
  },
  description: {
    fontSize: '24px',
    color: '#343d48cc',
    lineHeight: '30px',
    mb: '0',
  },
  btnStyle: {
    minWidth: ['120px', '458px'],
    fontSize: '22px',
    fontWeight: '500',
    color: "#FFFFFF",
    textAlign: "left"
  },
  outlineBtnStyle: {
    minWidth: ['130px', '156px'],
    fontSize: '14px',
    fontWeight: '500',
    color: '#0f2137',
    p: '5px 10px',
  },
  discountAmount: {
    fontSize: '14px',
    color: '#10AC84',
    mb: 0,
    as: 'span',
    mr: '0.4em',
  },
  discountText: {
    fontSize: '14px',
    color: '#0f2137',
    mb: 0,
    as: 'span',
  },
};

export default BannerSection;
